import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainContainer: {
        display: "flex",
    },
    dropdownContent: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
    },
    onlyContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "100% 0 0",
        backgroundColor: theme.palette.backgrounds.main,
    },
    leftContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "75% 0 0",
        backgroundColor: theme.palette.backgrounds.main,
    },
    rightContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "25% 0 0",
        padding: theme.spacing(4),
    },
    issueAndActionPlanNumberWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        fontSize: "14px",
        fontFamily: "Open Sans",
    },
    issueAndActionPlanNumberItem: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(5),
    },
    leftContentWrapper: {
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
    },
    divider: {
        width: "100%",
    },
    footer: {
        justifyContent: "flex-end",
        display: "flex",
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
        gap: theme.spacing(4),
    },
    extraDetailsContent: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    alertInfo: {
        "&.MuiPaper-root .MuiAlert-message": {
            color: theme.palette.text.primary,
            fontFamily: "Open Sans",
            fontWeight: 500,
            fontSize: 14,
        },
        alignItems: "center",
    },
}));
